module.exports = __webpack_public_path__ + "static/media/One More Night.5f58ed00.mp3";